import fetch from '../utils/fetch'

//获取班次设置列表
export function getScheduleConfig(params) {
  return fetch({
    method:'GET',
    url:'/business/getScheduleConfig/list',
    params
  })
}

//获取排班列表
export function getSchedule(params) {
  return fetch({
    method:'GET',
    url:'/business/getSchedule/list',
    params
  })
}

//更新排班
export function updateSchedule(params) {
  return fetch({
    method:'POST',
    url:'/business/updateSchedule',
    data:params
  })
}

//更新班次设置
export function updateScheduleConfig(params) {
  return fetch({
    method:'POST',
    url:'/business/updateScheduleConfig',
    data:params
  })
}

//获取项目所有管家
export function getProjectZos(params) {
  return fetch({
    method:'GET',
    url:'/basics/getProjectZos',
    params
  })
}



